<template>
  <div class="landing">
    <div class="landing__content">
      <div class="main">
        <div class="main__header">
          <div class="white-header"></div>
          <img
            class="logo absolute "
            src="@/assets/img/global/header_logo.svg"
          />
          <img class="w-full" src="@/assets/img/landing/header_bg.svg" />
        </div>
        <div class="main__body">
          <div class="text-box g-content">
            <h2 class="text-box__title">讓我們一起陪伴小腳ㄚ『過五關 ‧斬六將』</h2>

            <div class="text-box__title__desc-box">
              <p class="text-box__title__desc-box__text text-box__title__desc-box__text--wrap">
                <span class="text-box__title__desc-box__text__span">基金會結合各界的協助，</span>
                <span class="text-box__title__desc-box__text__span">為早產兒及其家庭點燃信心與希望，</span>
              </p>
              <p class="text-box__title__desc-box__text">推廣早產防與治的觀念與知識，</p>
              <p class="text-box__title__desc-box__text">讓每個早產兒有接受適當醫療的機會</p>
            </div>

            <div class="text-box__louder">
              <img class="text-box__louder__deco" src="@/assets/img/landing/deco_stick_left.png" />
              <p class="text-box__louder__text">新版官網，敬請期待</p>
              <img class="text-box__louder__deco" src="@/assets/img/landing/deco_stick_right.png" />
            </div>

            <div class="btn-wrap">
              <pr-button @click="toOldSite" arrow>
                <span class="btn-wrap__text">前往舊官網</span>
              </pr-button>
            </div>
          </div>

          <img class="main__body__bg-mobile" src="@/assets/img/landing/bg_mobile.png" />
          <img class="main__body__bg" src="@/assets/img/landing/bg.png" />

          <!-- 旗子 -->
          <img class="flag" src="@/assets/img/landing/deco_flag.png" />

          <!-- 雲朵們，定位 1-5 由左往右 -->
          <img class="cloud cloud--1" src="@/assets/img/landing/deco_cloud_1.png" />
          <img class="cloud cloud--2" src="@/assets/img/landing/deco_cloud_2.png" />
          <img class="cloud cloud--3" src="@/assets/img/landing/deco_cloud_2.png" />
          <img class="cloud cloud--4" src="@/assets/img/landing/deco_cloud_3.png" />
          <img class="cloud cloud--5" src="@/assets/img/landing/deco_cloud_1.png" />

          <!-- 鳥？ -->
          <div class="bird-purple">
            <img class="bird-purple__img" src="@/assets/img/landing/deco_bird_purple.png" />
          </div>
          <div class="bird-red">
            <img class="bird-red__img" src="@/assets/img/landing/deco_bird_red.png" />
          </div>
          <div class="bird-blue">
            <img class="bird-blue__img" src="@/assets/img/landing/deco_bird_blue.png" />
          </div>
        </div>
      </div>
      <!-- footer -->

      <footer class="footer">
        <div class="footer__content">
          <div class="contact-info">
            <p class="contact-info__text">地址 | 104台北市中山區民生東路一段42號8F之12</p>
            <p class="contact-info__text">電話 | (02)2511-1608</p>
            <p class="contact-info__text">傳真 | (02)2511-8553</p>
          </div>

          <div class="declare">
            <p class="declare__rights">© 2021 All Rights Reserved by Premature Baby Foundation of Taiwan.</p>
            <p class="declare__policy-terms">隱私權政策 | 服務條款</p>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import PrButton from '@/components/Global/PrButton.vue';

export default {
  name: 'Landing',
  components: {
    PrButton,
  },
  setup() {
    const toOldSite = () => {
      window.open('https://www.pbf.org.tw/', '_blank');
    };

    return {
      toOldSite,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';

.landing {

  background-color: $c-main-light-pink;
  overflow-y: auto;
  min-height: 100%;
  min-width: 100%;
  width: 100%;
  height: 100%;
  overflow-x: hidden;

}

.landing__content {
  @include flex(flex-start, flex-start, column);
  width: 100%;
  height: 100%;
  overflow-x: hidden;width: 100%;
  height: 100%;
  overflow-x: hidden;

}

.main {

  flex: 1;
  width: 100%;
  position: relative;

  &__header {

    z-index: 20px;
    @include position(tl, 0, 0);
    width: 100%;
  }

  &__body {
    width: 100%;

    &__bg-mobile {
      @include position(lb, 0, 0);
      width: 100%;

      @media screen and (min-width: $portrait) {
        display: none;
      }
    }

    &__bg {
      display: none;

      @media screen and (min-width: $portrait) {
        @include position(tl, 0, 0);
        display: block;
        width: 100%;
      }
    }
  }
}

// 190,
.logo {
  width: 190px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -52%);

  z-index: 10;
  // left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10

  // height: 75px;

  @media screen and (min-width: $portrait) {
    width: 230px;
    // height: 100px;
  }
}

.white-header {
  width: 100%;
  background-color: $c-white;
  height: 138px;

  @media screen and (min-width: $portrait) {
    height: 100px;
  }
}
.header {
  width: 100%;
  width: 100%;
  height: 150px;

  @media screen and (min-width: $portrait) {
    height: 134px;
  }
}

.footer {
  /* height: 60px; */
  width: 100%;
  flex: none;
  height: auto;

  @media screen and (min-width: $pc) {
    height: 60px;
  }

  &__content {
    @include flex(space-between, flex-start, column);
    max-width: 1366px;
    margin: 0 auto;
    height: 100%;
    padding: 24px;

    @media screen and (min-width: $portrait) {
      align-items: center;
    }

    @media screen and (min-width: $pc) {
      flex-direction: row;
      padding: 0

    }
  }
}

.text-box {
  margin: 0 auto;
  position: relative;
  z-index: 10;
  padding-bottom: 80vw;
  padding-top: 192px;

  @media screen and (min-width: $portrait) {
    padding-bottom: 40vw;
  }

  @media screen and (min-width: $tablet) {
    padding-bottom: 30vw;
  }

  @media screen and (min-width: $sm-pc) {
    max-width: 1000px;
  }

  @media screen and (min-width: $pc) {
    padding-top: 240px;
    padding-bottom: 30vw;
    // max-width: 1134px;
    max-width: 1360px;
  }

  @media screen and (min-width: $lg-pc) {
    padding-top: 300px;

  }

  &__title {
  @include font-style($c-main, 20, 700, 2px);

    @media screen and (min-width: $mobile) {
      @include font-size(26);
    }

    @media screen and (min-width: $portrait) {
      @include font-size(45);
      letter-spacing: 4.5px;
    }

    &__desc-box {
      margin-top: 16px;

      &__text {

        @include font-style($c-main, 14, 400, 1px);
        @media screen and (min-width: $mobile) {
          @include font-size(16);
          letter-spacing: 1.6px;

        }

        @media screen and (min-width: $portrait) {

          @include font-size(20);
          line-height: 28px;

        }

        &--wrap {
          @media screen and (min-width: $sm-pc) {
            .text-box__title__desc-box__text__span {
              display: inline-block;
            }
          }
        }

        &__span {
          display: block;
          word-break: break-all
        }
      }
    }
  }

  &__louder {
    margin-top: 28px;
    @include flex();
    font-weight: 700;

    &__deco {
      width: 15px;

      @media screen and (min-width: $portrait) {
        width: 36px;
      }
    }

    &__text {

  @include font-style($c-main, 20, 400, 2px);
  margin-left: 20px;
  margin-right: 20px;

      @media screen and (min-width: $mobile) {

        @include font-size(26);

      }
      @media screen and (min-width: $portrait) {

        @include font-style($c-main, 45, 700, 4.5px);

      }
    }
  }
}

.btn-wrap {

  margin-top: 28px;

  &__text {

    color: $c-main;
    letter-spacing: 1.6px;
  }
}

.flag {
  width: 22vw;
  @include position(tr, 140px, -5px);
  display: block;

  @media screen and (min-width: $portrait) {
    display: inline-block;
    top: 110px;
  }
}

.contact-info {
  // display: flex;
flex-direction: column;

  @media screen and (min-width: $portrait) {
    @include flex(flex-start, flex-start, row);
  }

  &__text {
    @include font-style($c-white, 14, 400, 1.4px);
    text-align: left;
    // text-align: center;

    @media screen and (min-width: $portrait) {
      display: inline-block;
      margin-left: 16px;
      text-align: left;
      top: 110px;
    }
  }
}

.declare {
  @include flex(flex-start, flex-start, column);
  margin-top: 8px;

  @media screen and (min-width: $portrait) {
    margin-top: 4px;
    @include flex();

  }

  @media screen and (min-width: $pc) {
    @include flex(space-between, center);
    margin-top: 0;
  }

  &__rights {
    @include font-style(rgba($c-white, 0.5), 14, 400, 1.4px);
    @media screen and (min-width: $portrait) {

      text-align: left;
    }
  }

  &__policy-terms {
    @include font-style(rgba($c-white, 0.5), 14, 400, 1.4px);
    text-align: center;

    @media screen and (min-width: $portrait) {
      margin-left: 12px;
      text-align: left;
    }
  }
}

.cloud {
  position: absolute;

  &--1 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 10.5vw;
      top: 180px;
      // bottom: 60vw;
      left: 6vw;
      animation: 2s cloudFlow infinite forwards linear;
    }

    @media screen and (min-width: $sm-pc) {
      left: 3vw;
      // bottom: 51vw;
    }

    @media screen and (min-width: $pc) {
      left: 3vw;
      // bottom: 43vw;
    }
  }

  &--2 {

    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 7vw;
      animation: 2.3s cloudFlow infinite forwards linear;
      bottom: 25vw;
      left: 50vw;
    }

    @media screen and (min-width: $pc) {
      bottom: 20vw;
      left: 40vw;
    }
  }
  &--3 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 7vw;
      animation: 1.9s cloudFlow infinite forwards linear;
      bottom: 29vw;
      left: 58vw;
    }

    @media screen and (min-width: $pc) {
      bottom: 25vw;
      left: 47vw;
    }
  }
  &--4 {
    width: 8vw;
    top: 30%;
    left: 70%;
    animation: 2.1s cloudFlow infinite forwards linear;
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
    }
  }

  &--5 {
    display: none;

    @media screen and (min-width: $tablet) {
      display: inline-block;
      width: 10.5vw;
      bottom: 50%;
      right: -1%;
      animation: 1.8s cloudFlow infinite forwards linear;
    }

  }
}

.bird-purple {
  @include position(bl, 7vw, 38%);

  @media screen and (min-width: $portrait) {
    bottom: 4vw;
  }

  &__img {
    width: 9vw;
    animation: 20s purpleBirdWalking infinite linear;

    @media screen and (min-width: $portrait) {
      width: 4.5vw;
    }
  }
}

.bird-red {
  @include position(bl, 5vw, 45%);

  @media screen and (min-width: $portrait) {
    bottom: 3vw;
  }

  &__img {
    width: 9vw;
    animation: 15s redBirdWalking infinite linear;

    @media screen and (min-width: $portrait) {
      width: 4.5vw;
    }
  }
}

.bird-blue {
  @include position(bl, 6vw, 60%);

  @media screen and (min-width: $portrait) {
    bottom: 2vw;
  }

  &__img {
    width: 22vw;
    animation: 2s blueFlow infinite linear;

    @media screen and (min-width: $portrait) {
      width: 10vw;
    }
  }
}

@keyframes cloudFlow {
  0% {
    transform: translateX(0px) rotate(0deg);
  }

  25% {
    transform: translateX(5px) rotate(5deg);
  }

  75% {
    transform: translateX(-5px) rotate(-5deg);
  }

  100% {
    transform: translateX(0px) rotate(0deg);
  }
}

@keyframes purpleBirdWalking {
  0% {
    transform: translateX(0px);
  }

  24% {
    transform: translateX(10vw);
  }

  25% {
    transform: translateX(10vw) rotateY(180deg);
  }

  75% {
    transform: translateX(-10vw) rotateY(180deg);
  }

  76% {
    transform: translateX(-10vw) rotateY(0deg);
  }

  100% {
    transform: translateX(0px);
  }
}

@keyframes redBirdWalking {
  0% {
    transform: translateX(0px);
  }

  24% {
    transform: translateX(7vw);
  }

  25% {
    transform: translateX(7vw) rotateY(180deg);
  }

  75% {
    transform: translateX(-7vw) rotateY(180deg);
  }

  76% {
    transform: translateX(-7vw) rotateY(0deg);
  }

  100% {
    transform: translateX(0px);
  }
}

@keyframes blueFlow {
  0% {
    transform: translateX(0px) rotate(0deg);
  }

  25% {
    transform: translateX(5px) rotate(1deg);
  }

  75% {
    transform: translateX(-5px) rotate(-1deg);
  }

  100% {
    transform: translateX(0px) rotate(0deg);
  }
}

</style>
